import { useQuery } from '@tanstack/react-query'
import { getTicketsLockedByUser } from 'api/generalTicket'

export const useTicketsLockedByUser = (eventId: string, lockKey: string) => {
    const { data, error, isLoading, refetch } = useQuery<any[]>({
        queryKey: ['ticketsLockedByUser', eventId, lockKey],
        queryFn: async () => {
            if (!eventId) throw new Error('No event ID provided')
            if (!lockKey) throw new Error('No lock key provided')
            return getTicketsLockedByUser(eventId, lockKey)
        },
        enabled: !!eventId && !!lockKey,
    })

    return {
        data,
        error,
        isLoading,
        refetch,
    }
}
